import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SessionService } from "../../core/services/session.service";
import { BeneficiaryService } from "../../core/services/beneficiary.service";
import { Beneficiario } from "../../core/models/beneficiary.model";
import { PageEvent } from '@angular/material/paginator';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RequirementService } from "../../core/services/requirement.service";
import { Router, RouterOutlet } from "@angular/router";

@Component({
  standalone: true,
  imports: [CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,],
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {

  token: string | null = null;
  guardiao: any | undefined = null;

  tipo: string | null = null;

  page = 0;

  maxpage = 10;

  length = 0;

  loading = false;

  public form!: FormGroup;

  beneficiarios: Beneficiario[] = [];

  displayedColumns: string[] = ['idFuncional', 'cpf', 'nome', 'matricula', 'orgao', 'acoes'];

  organizations = [
    { label: 'PMCE', value: 43 },
    { label: 'CBMCE', value: 44 }
  ]

  constructor(private fb: FormBuilder,
    private sessionService: SessionService,
    private beneficiaryService: BeneficiaryService,
    private requirementService: RequirementService,
    private router: Router) {

  }

  ngOnInit(): void {
    this.form = this.fb.group({
      idFuncional: [''],
      cpfConsulta: [''],
      nomeConsulta: [''],
      idOrgao: [''],
      matriculaConsulta: ['']
    });

    this.token = this.sessionService.token;
    this.tipo = this.sessionService.tipoBeneficiario;

    // Se quiser, pode usar direto no HTML também via property binding
    console.log('Token:', this.token);
    console.log('guardiao:', this.guardiao);
    console.log('Tipo:', this.tipo);
  }

  limpar(): void {
    this.form.reset();
  }

  requerimento(beneficiary: any): void {
    this.sessionService.beneficiario = beneficiary;
    console.log('beneficiary: ',beneficiary)
    const filtros = this.form.value;
   const queryParams = Object.entries(filtros)
  .filter(([_, valor]) => valor !== null && valor !== '')
  .reduce((acc, [chave, valor]) => {
    acc[chave] = String(valor);
    return acc;
  }, {} as { [key: string]: string });
    this.requirementService.getRequirement(beneficiary.matricula, beneficiary.orgao.id,queryParams).subscribe({
      next: (res) => {
        console.log('res: ',res.anexado)
        if(res.anexado) {
          this.router.navigateByUrl('/dados-pessoais', {
            state: {
              data: {
                ...beneficiary
              }
            }
          });
        } else {
          this.router.navigateByUrl('/requirement', {
            state: {
              data: {
                ...beneficiary
              }
            }
          });
        }
      },
      error: (err) => {
        console.error('Erro ano requerimento', err);
        this.loading = false;
      }
    })

  }

  pesquisar(): void {
    this.loading = true;
    console.log(this.form.value)

    const filter = this.form.value;

    this.beneficiaryService.getBeneficiarios(this.page, this.maxpage, filter).subscribe({
      next: (res) => {
        this.beneficiarios = res.results;
        this.length = res.total;
        this.loading = false;
      },
      error: (err) => {
        console.error('Erro ao buscar beneficiários', err);
        this.loading = false;
      }
    });
  }

  onPageChange(event: PageEvent): void {
    this.page = event.pageIndex;
    this.maxpage = event.pageSize;
    this.pesquisar();
  }
}
